import * as React from 'react';
import warning from 'warning';
export var listOpenStateHandlersContext = React.createContext([
    false,
    function () {
        warning(true, "you aren't in a listOpenStateContext");
    },
]);
